import React from 'react';
import { cn } from '../../lib/utils';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from './dialog';

/**
 * Standard app modal — Radix Dialog with consistent layout.
 */
function ModalDialog({
  open = true,
  onClose,
  title,
  description,
  children,
  footer,
  className,
  closeLabel = 'Close',
}) {
  return (
    <Dialog open={open} onOpenChange={(next) => !next && onClose?.()}>
      <DialogContent
        className={cn('max-h-[90vh] overflow-y-auto', className)}
        closeLabel={closeLabel}
      >
        {(title || description) && (
          <DialogHeader>
            {title ? <DialogTitle>{title}</DialogTitle> : null}
            {description ? <DialogDescription>{description}</DialogDescription> : null}
          </DialogHeader>
        )}
        {children}
        {footer ? <DialogFooter>{footer}</DialogFooter> : null}
      </DialogContent>
    </Dialog>
  );
}

export { ModalDialog };
